(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _segment_next_shared_404__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96827);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52903);



var Error = function Error() {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_segment_next_shared_404__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {});
};

/* harmony default export */ __webpack_exports__["default"] = (Error);

/***/ }),

/***/ 4203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Image; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/Image.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)((image_default()),  true ? {
  target: "eulst6f0"
} : 0)( true ? {
  name: "11726p1",
  styles: "height:auto;position:relative;margin:0 auto;display:block"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/Image.tsx


var _excluded = ["src", "alt", "width", "height", "unoptimized", "loader"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var imageLoader = function imageLoader(_ref) {
  var src = _ref.src;
  return "".concat(src);
};

var Image = function Image(_ref2) {
  var src = _ref2.src,
      alt = _ref2.alt,
      width = _ref2.width,
      height = _ref2.height,
      _ref2$unoptimized = _ref2.unoptimized,
      unoptimized = _ref2$unoptimized === void 0 ? true : _ref2$unoptimized,
      loader = _ref2.loader,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, _objectSpread(_objectSpread({
    loader: loader || imageLoader,
    width: width,
    height: height,
    src: src,
    alt: alt
  }, props), {}, {
    unoptimized: loader ? false : unoptimized
  }));
};
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/index.ts


/***/ }),

/***/ 96827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ _404; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
;// CONCATENATED MODULE: ../../libs/next-shared/404/data.json
var data_namespaceObject = JSON.parse('[{"text":"Segment Home","url":"https://segment.com/"},{"text":"Docs","url":"https://segment.com/docs/"},{"text":"Login","url":"https://segment.com/login/"},{"text":"Customer AI","url":"https://segment.com/solutions/ai/"},{"text":"HTTP API Source","url":"https://segment.com/docs/sources/server/http/"},{"text":"Get a Demo","url":"https://segment.com/demo/"},{"text":"Data Hub","url":"https://segment.com/data-hub/"},{"text":"Growth Center","url":"https://segment.com/growth-center/"},{"text":"Resources","url":"https://segment.com/resources/"},{"text":"Blog","url":"https://segment.com/blog/"}]');
// EXTERNAL MODULE: ../../libs/next-shared/404/assets/Error.webp
var Error = __webpack_require__(19282);
var Error_default = /*#__PURE__*/__webpack_require__.n(Error);
// EXTERNAL MODULE: ../../libs/next-shared/404/assets/Error@2x.webp
var Error_2x = __webpack_require__(55901);
var Error_2x_default = /*#__PURE__*/__webpack_require__.n(Error_2x);
// EXTERNAL MODULE: ../../libs/next-shared/404/assets/Error@2x.png
var assets_Error_2x = __webpack_require__(90490);
var assets_Error_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Error_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/next-shared/404/404.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}















var copy = {
  heading: "Whoops!",
  description: "Error code: 404. Unfortunately, the page you are looking for does not exist.",
  error: "Here are some helpful links instead:"
};

var ErrorView = function ErrorView() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(layout/* default */.Z, {
      pageTitle: "404 | Twilio Segment",
      pageDescription: "",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
          variant: "2Col",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "h1",
                children: copy.heading
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pExtraLarge",
                children: copy.description
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
              variant: "pExtraLarge",
              children: copy.error
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
              columns: 1,
              overrides: {
                sm: 2
              },
              children: data_namespaceObject.map(function (el) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonTextWrapper, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                    tag: "a",
                    size: "medium",
                    href: el.url,
                    children: el.text
                  })
                }, el.text);
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
            alignSelf: "center",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                type: "image/webp",
                srcSet: "".concat((Error_default()), ", ").concat((Error_2x_default()), " 2x")
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
                width: "641",
                height: "555",
                src: (assets_Error_2x_default()),
                alt: "Collect Data Details",
                loading: "lazy"
              })]
            })
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var _404 = (ErrorView);

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fr5jqi3"
} : 0)("display:grid;flex-direction:column;align-items:center;min-height:100vh;grid-template-rows:max-content;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1fr5jqi2"
} : 0)("row-gap:0;margin-bottom:40px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{margin-bottom:0;}" + ( true ? "" : 0));

var StyledButtonTextWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fr5jqi1"
} : 0)( true ? "" : 0);

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1fr5jqi0"
} : 0)( true ? {
  name: "1eclne9",
  styles: "max-width:360px"
} : 0);
;// CONCATENATED MODULE: ../../libs/next-shared/404/index.ts


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 99133:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(345);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90490:
/***/ (function(module) {

module.exports = "/_next/static/images/Error@2x-fed5968fdecab1fac471000d1a501a5f.png";

/***/ }),

/***/ 19282:
/***/ (function(module) {

module.exports = "/_next/static/images/Error-1cf5b1c4a99d1faec03c30c5e9fd5e64.webp";

/***/ }),

/***/ 55901:
/***/ (function(module) {

module.exports = "/_next/static/images/Error@2x-4995b132adf9c49b6cfb16e99e6fc77f.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,6577,3607,1382,2073,8392,5735,7303,9774,2888,179], function() { return __webpack_exec__(99133); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);